import React, { useState } from 'react';
import { ReactComponent as IconChat } from '../../assets/icons/icon-chat.svg';
import { ReactComponent as IconSend } from '../../assets/icons/icon-send.svg';
import { ReactComponent as IconFile } from '../../assets/icons/icon-plus.svg';
const Chat = () => {
  const [showChatting, setShowChatting] = useState(false);
  return (
    <div
      className={
        'fixed bottom-0 right-0 z-30 mr-10' +
        (showChatting ? ' max-w-sm w-full' : ' w-32')
      }
    >
      {showChatting ? (
        <div className="flex flex-col items-center justify-center bg-white shadow-t-2xl rounded-t-md ">
          <div className="header-chat px-4 py-3 border-b border-gray-200 flex items-center w-full">
            <IconChat className="w-4 h-4 mr-4" />
            <h5 className="font-semibold text-basic-orange">Admin</h5>
            <button
              className="text-lg ml-auto"
              onClick={() => {
                setShowChatting(!showChatting);
              }}
            >
              X
            </button>
          </div>
          <div className="body-chat max-h-70 flex flex-col overflow-y-auto py-2 px-2 w-full">
            <div className="flex flex-col" id="sender">
              <div className="flex flex-col w-full items-end" id="message-1">
                <div className="flex items-end justify-center bg-gray-200 pl-4 pr-6 py-3 rounded-xl rounded-br-none min-w-fit-content max-w-xs text-sm">
                  Apa kabar ?
                </div>
                <p className="my-2 text-xs">8.15</p>
              </div>
            </div>
            <div className="flex flex-col" id="receiver">
              <div className="flex flex-col w-full items-start" id="message-1">
                <div className="flex items-start justify-center bg-basic-orange text-white pl-6 pr-4 py-3 rounded-xl rounded-bl-none min-w-fit-content max-w-xs text-sm">
                  Baik Alhamdulillah
                </div>
                <p className="my-2 text-xs">8.15</p>
              </div>
            </div>
            <div className="flex flex-col" id="sender">
              <div className="flex flex-col w-full items-end" id="message-1">
                <div className="flex items-end justify-center bg-gray-200 pl-4 pr-6 py-3 rounded-xl rounded-br-none min-w-fit-content max-w-xs text-sm">
                  Apa kabar ?
                </div>
                <p className="my-2 text-xs">8.15</p>
              </div>
            </div>
            <div className="flex flex-col" id="sender">
              <div className="flex flex-col w-full items-end" id="message-1">
                <div className="flex items-end justify-center bg-gray-200 pl-4 pr-6 py-3 rounded-xl rounded-br-none min-w-fit-content max-w-xs text-sm">
                  Apa kabar ?
                </div>
                <p className="my-2 text-xs">8.15</p>
              </div>
            </div>
          </div>
          <div className="footer-card shadow-t-xl py-3 px-4 w-full flex">
            <div htmlFor="" className="relative flex-grow pr-4">
              <label className="absolute bg-white p-1 rounded-full ml-2 mt-3 cursor-pointer">
                <IconFile className="h-4 w-4" />
                <input type="file" className="hidden" />
              </label>
              <input
                type="text"
                className="form-input mt-1 block w-full text-sm bg-gray-200 rounded-r-full rounded-l-full pl-12 border-none"
              />
            </div>
            <button className="py-2 bg-basic-orange rounded-full flex-none px-3 flex items-center justify-center">
              <IconSend className="w-4 h-4 ml-1" />
            </button>
          </div>
        </div>
      ) : (
        <div
          className=" flex items-center justify-center bg-white shadow-t-2xl px-4 py-3 rounded-t-md cursor-pointer"
          onClick={() => {
            setShowChatting(!showChatting);
          }}
        >
          <IconChat className="w-4 h-4 mr-4" />
          <p className="font-semibold text-font-gray">Chat</p>
        </div>
      )}
    </div>
  );
};

export default Chat;
